import {Col, Row} from "react-bootstrap";
import {Block} from "../components";
import React from "react";
import {usePropState} from "../utils";
import {useTranslation} from "react-i18next";
import ShowItem from "../ShowItem";
import IabLogo from '../../../assets/images/layout4/iab-logo.png';
import styled from "styled-components";
import * as Format from "../Format";
import {formatDate} from "../Format";
import isEmpty from "lodash/isEmpty";

function CpmElement({cpm}) {

  const cpm2FromTo = function(cpm) {
    let valList = Object.keys(cpm).map((x)=>parseInt(x)).sort();
    let res = [];
    for (const val of valList) {
      if(res.at(-1)) { res.at(-1)["to"] = val }
      res.push({from: val, value: cpm[val]});
    }
    return res;
  }
  const cpmList = cpm2FromTo(cpm);

  if (cpmList.length === 1) {
    return <Format.Price value={cpmList[0]["value"]} />
  } else {
    return cpmList.map((cpm, index)=>{
      return (
        <div key={cpm["from"]}>
          <Format.Number value={cpm["from"]} />
          { cpm["to"] && <>
            <span> - </span>
            <Format.Number value={cpm["to"]} />
          </>}
          <span> : </span>
          <Format.Price value={cpm["value"]} digits={1} />
        </div>
      )
    })
  }
}

const InlineImg = styled.img`
  width: 30px;
  padding-bottom: 6px;
  margin-left: 5px;
`

export default function DataVendorInfos(props) {
  const [dataVendor,] = usePropState(props.dataVendor)

  return (
    <>
      <MainInfos dataVendor={dataVendor}/>
      { dataVendor.cmp_vendor && <Privacy dataVendor={dataVendor} /> }
      <PublisherScope dataVendor={dataVendor}/>
      {dataVendor.environment === "production" && <Billing dataVendor={dataVendor}/>}
      <OptOut dataVendor={dataVendor}/>
      { !isEmpty(dataVendor.wifi_network_ssids) && <WifiNetwork dataVendor={dataVendor}/>}
    </>
  )
}

function MainInfos({dataVendor}) {
  const { t } = useTranslation();

  return (
    <Block>
      <ShowItem label={t("dataVendor.bucket")} value={`s3://data-stream-partners-sink/${dataVendor.bucket}`} />
      <ShowItem label={t("dataVendor.environment")} value={dataVendor.environment} />
      <ShowItem label={t("dataVendor.billing_start_date")} value={formatDate(dataVendor.billing_start_date)} />
      <ShowItem label={t("dataVendor.industry")} value={dataVendor.industry} />
      <ShowItem label={t("dataVendor.terminated_at")} value={formatDate(dataVendor.terminated_at)} />
      <ShowItem label={t("dataVendor.isPublisher")} value={!!dataVendor.publisher_id} bool />
      { (dataVendor.publisher) && <ShowItem label={t("dataVendor.publisher")} value={dataVendor.publisher.name} /> }
    </Block>
  )
}

function Privacy({dataVendor}) {
  const { t } = useTranslation();
  return (
    <Block title={t("dataVendor.privacy")}>
      <ShowItem label={t("dataVendor.cmp_vendor")} value={<>
        {dataVendor.cmp_vendor.name}
        {dataVendor.cmp_vendor.iab_id && <InlineImg src={IabLogo}/>}
      </>} />
    </Block>
  )
}

function PublisherScope({dataVendor}) {
  const { t } = useTranslation();
  const hasPublisherScope = !!(dataVendor.publisher_ids && dataVendor.publisher_ids.length > 0)

  return (
    <Block title={t("dataVendor.publisherScope")}>
      <ShowItem key={"hasPublisherScope"} label={t("dataVendor.hasPublisherScope")} value={hasPublisherScope} bool />
      {hasPublisherScope && <>
        <ShowItem key={"publishers"} label={t("dataVendor.publishers")} value={dataVendor.publisher_names} array />
        <ShowItem key={"blacklist"} label={t("dataVendor.blacklist")} value={t(`dataVendor.${dataVendor.blacklist ?'exclude' : 'only'}`)} />
      </>}
    </Block>
  )
}

function Billing({dataVendor}) {
  const { t } = useTranslation();
  return (
    <Block title={t("dataVendor.billing")}>
      <ShowItem key={"billingModel"} label={t("dataVendor.billingModel")} value={t(`billing.${dataVendor.billing_model}`)} />
      { dataVendor.billing_model !== 'flat' && <>
        <ShowItem key={"max_users"} label={t("dataVendor.max_users")} value={dataVendor.max_users ? <Format.Number value={dataVendor.max_users}/> : '-'} />
        <ShowItem key={"cpm"} label={t("dataVendor.cpm")} value={<CpmElement cpm={dataVendor.cpm}/>} />
      </>}
      { dataVendor.billing_model === 'flat' && <ShowItem key={"flat_fee"} label={t("dataVendor.flat_fee")} value={<Format.Price value={dataVendor.flat_fee}/>} />}
    </Block>
  )
}

function WifiNetwork({dataVendor}) {
  const { t } = useTranslation();
  return (
    <Block title={t("dataVendor.wifiNetwork")}>
      <ShowItem key={"wifiNetwork"} label={t("dataVendor.wifiNetwork")} value={dataVendor.wifi_network_ssids} array />
    </Block>
  )

}

function OptOut({dataVendor}) {
  const { t } = useTranslation();
  
  return (
    <Block title={t("dataVendor.optOut")}>
      <ShowItem key={"withOptOut"} label={t("dataVendor.withOptOut")} value={dataVendor.with_opt_out} bool />
    </Block>
  )  
}
